import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'contract-box',
    templateUrl: './contract-box.component.html',
    styleUrls: ['./contract-box.component.scss'],
    standalone: false
})
export class ContractBoxComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
